import React from "react";

export const SectionHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="cw-text-13 cw-font-semibold cw-text-default cw-leading-5 ">{children}</div>
  );
};
